import getClient from "./getClient";

export default function signUp({ email, metadata }) {
  return getClient().auth.signInWithOtp({
    email,
    options: {
      data: metadata,
    },
  });
}
